export default __webpack_public_path__ + "static/media/_IMG1906.74943120.jpg";